import React from "react";
import MobileButton from "@/components/MobileButton";
import "./index.scss";
import { useTranslation } from "react-i18next";

const ErrorPopupThreeInOne = ({
    showErrorPopup,
    className = "ErrorPopupThreeInOne",
    title,
    content,
    buttonText,
    buttonConfirmText,
    errorCallback = () => {},
    isShowButton = false,
}) => {
    const { t } = useTranslation();
    return (
        <div
            className={`${className} ${
                buttonConfirmText && buttonText ? "multiple" : ""
            }`}
        >
            <div className={`${className}-title`}>{t(title)}</div>
            {isShowButton ? (
                <div
                    className={`${className}-content`}
                    dangerouslySetInnerHTML={{
                        __html: t(
                            typeof content === "string"
                                ? content
                                : content?.msg,
                            { code: content?.code }
                        ).replace("()", ""),
                    }}
                ></div>
            ) : (
                <div className={`${className}-content`}>
                    {t(typeof content === "string" ? content : content?.msg, {
                        code: content?.code,
                    }).replace("()", "")}
                </div>
            )}
            <div className={`${className}-button-wapper`}>
                {buttonText && (
                    <MobileButton
                        type={buttonConfirmText ? "outlined" : "filled"}
                        onClick={() => {
                            errorCallback?.();
                            showErrorPopup("");
                        }}
                    >
                        {t(buttonText)}
                    </MobileButton>
                )}

                {buttonConfirmText && (
                    <MobileButton
                        onClick={() => {
                            errorCallback?.();
                            showErrorPopup("");
                        }}
                    >
                        {t(buttonConfirmText)}
                    </MobileButton>
                )}
            </div>
        </div>
    );
};
export default ErrorPopupThreeInOne;
